// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"navigate_navWrapper__3nJDN","isHidden":"navigate_isHidden__1kAHM","isVisible":"navigate_isVisible__UFwm_"};